import React, { FunctionComponent } from 'react'
import { Helmet } from 'react-helmet'
import Footer from './Footer'

import Header from './Header'
import { IFooterData, IHeaderData } from 'Root/src/queries/layout-queries'

interface LayoutPropsType {
    customLayoutClass?: string
    style?: string
    footerData: IFooterData
    headerData: IHeaderData
}

const Layout: FunctionComponent<LayoutPropsType> = (props) => {
    const classes = [`layout-main`, props.customLayoutClass]

    return (
        <>
            <Helmet>
                <script type="text/javascript" src='https://secure.peak2poem.com/js/195773.js' defer></script>
                <link
                    rel='apple-touch-icon'
                    sizes='180x180'
                    href={process.env.GATSBY_WEBSITE_URL + `/apple-touch-icon.png`}
                />
                <link
                    rel='icon'
                    type='image/png'
                    sizes='32x32'
                    href={process.env.GATSBY_WEBSITE_URL + `/favicon-32x32.png`}
                />
                <link
                    rel='icon'
                    type='image/png'
                    sizes='16x16'
                    href={process.env.GATSBY_WEBSITE_URL + `/favicon-16x16.png`}
                />
                <link
                    rel='manifest'
                    href={process.env.GATSBY_WEBSITE_URL + `/site.webmanifest`}
                />
                <link
                    rel='mask-icon'
                    href={process.env.GATSBY_WEBSITE_URL + `/safari-pinned-tab.svg`}
                    color='#0080ff'
                />
                <meta name='msapplication-TileColor' content='#ffffff' />
                <meta name='theme-color' content='#ffffff' />
                <body className={process.env.GATSBY_PROJECT !== `cs` ? `ENUS` : `CSCZ`} />
            </Helmet>
            <noscript>
                <img src='https://secure.peak2poem.com/195773.png' alt="" style={{ display: "none" }} />
            </noscript>
            <Header
                customHeaderClass={props.customLayoutClass}
                style={props.style}
                headerData={props.headerData}
            />
            <main className={classes.join(` `)}>{props.children}</main>
            {/* <PuxNewsletterForm /> */}
            <Footer footerData={props.footerData} />
        </>
    )
}

export default Layout